import gql from "graphql-tag";

export default gql`
	mutation updateMacro($id: ID, $update: Update, $parentId: ID) {
		macro(id: $id, update: $update, parentId: $parentId)
	}
`;
